var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericSelector',{attrs:{"options":_vm.sizes,"model":_vm.model,"label":"Container size"}})}
var staticRenderFns = []

export { render, staticRenderFns }